import { AfterViewInit, Component, EventEmitter, Input, Output, ViewEncapsulation, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {ActivityInterface} from '../../../class/api/Activity';
import {MatDialog} from '@angular/material/dialog';
import {TaskCompletedRequest} from '../../../class/api/TaskCompletedRequest';
import {ModalCommentaireComponent} from '../modal-commentaire/modal-commentaire.component';
import {AuthentificationService} from '../../../core/services/authentification.service';
import { DatePipe } from '@angular/common';
import { MatList, MatListItem, MatListItemAvatar, MatListItemTitle, MatListItemLine } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { LogCommentsListComponent } from '../log/log-comments-list/log-comments-list.component';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-tasks-list',
    templateUrl: './tasks-list.component.html',
    styleUrls: ['./tasks-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatList, MatListItem, MatIcon, MatListItemAvatar, MatListItemTitle, MatListItemLine, MatButton, LogCommentsListComponent, MatDivider, DatePipe]
})
export class TasksListComponent implements AfterViewInit {
    private hydraService = inject(HydraService);
    private authService = inject(AuthentificationService);
    private matDialog = inject(MatDialog);


    public initComplete = false;

    private _action: string;
    @Input() set action(action: string) {
        this._action = action ?? '';
        if (this.initComplete) {
            this.loadTasks();
        }
    };

    private _target: string;
    @Input() set target(target: string) {
        this._target = target ?? '';
        if (this.initComplete) {
            this.loadTasks();
        }
    };

    private _showCompletedTasks = true;
    @Input() set showCompletedTasks(showCompletedTasks: boolean) {
        this._showCompletedTasks = showCompletedTasks ?? true;
        if (this.initComplete) {
            this.loadTasks();
        }
    }

    @Input() set version(version: number) {
        this.loadTasks();
    }

    @Input() dense = false;

    @Output() taskCompleted = new EventEmitter<ActivityInterface>();

    @Output() numberTasks = new EventEmitter<number>();

    public tasksList: ActivityInterface[] = [];

    public isBusy = false;
    public isAdmin = false;

    constructor() {
        this.isAdmin = this.authService.isAdmin();
    }

    public reload() {
        this.loadTasks();
    }

    public loadTasks() {
        let url = api.activities + '?pagination=false&task=true';

        if(this._target && this._target.length){
            url += '&target=' + this._target;
        }

        if(this._action && this._action.length){
            url += '&action=' + this._action;
        }

        if (!this._showCompletedTasks) {
            url += '&taskComplete=false';
        }

        this.hydraService.getList(url).subscribe((res: HydraCollection) => {
            this.tasksList = (new HydraCollection(res)).getMember();
            this.numberTasks.emit(this.tasksList.length);
        });
    }

    public setTaskCompleted(activity: ActivityInterface) {
        this.isBusy = true;
        const dialog = this.matDialog.open(ModalCommentaireComponent, {
            data: {
                content: 'Confirmez vous que la tâche \'' + activity.title + '\' a été traitée ?',
                confirm: 'Oui',
                cancel: 'Non',
            },
            panelClass: 'arc-dialog-panel',
            backdropClass: 'arc-dialog-backdrop'
        });
        dialog.afterClosed().subscribe((res: false | { commentaire: string }) => {
            if (res) {
                const data = new TaskCompletedRequest(
                    {
                        activity: activity['@id'],
                        commentaire: res.commentaire
                    }
                );

                this.hydraService.post('/api/activities/taskCompleted', data).subscribe(
                    () => {
                        this.taskCompleted.emit(activity);
                        this.loadTasks();
                        this.isBusy = false;
                    },
                    () => {
                        this.isBusy = false;
                    }
                );
            } else {
                this.isBusy = false;
            }
        });

    }

    public showCommentBox(activity) {
        activity['showCommentBox'] = true;
    }

    ngAfterViewInit() {
        this.loadTasks();
        this.initComplete = true;
    }
}
